import { useCallback, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/AppShell.jsx';
import PullToRefresh from './components/PullToRefresh.jsx';
import EventsPage from './pages/EventsPage.jsx';
import HeutePage from './pages/HeutePage.jsx';
import EventDetailPage from './pages/EventDetailPage.jsx';
import PokemonPage from './pages/PokemonPage.jsx';
import PokemonDetailPage from './pages/PokemonDetailPage.jsx';
import RaidsPage from './pages/RaidsPage.jsx';
import AdminPage from './pages/AdminPage.jsx';
import MyAreaPage from './pages/MyAreaPage.jsx';
import PvpPage from './pages/PvpPage.jsx';
import FangenPage from './pages/FangenPage.jsx';
import ScanPage from './pages/ScanPage.jsx';
import RaidTeamPage from './pages/RaidTeamPage.jsx';
import StatsPage from './pages/StatsPage.jsx';
import AccountPage from './pages/AccountPage.jsx';
import { PasswordForgotPage, PasswordResetPage, VerifyPage } from './pages/PasswordPages.jsx';

export default function App() {
  // Jede Seite lädt ihre Daten beim Einhängen. Ein Wechsel dieses Schlüssels
  // hängt den ganzen Baum neu ein — damit laden alle Seiten neu, ohne dass
  // jede einzelne eine eigene Aktualisieren-Funktion braucht.
  const [stand, setStand] = useState(0);

  const neuLaden = useCallback(async () => {
    setStand((n) => n + 1);
    // Kurz stehen lassen, sonst blitzt die Anzeige nur auf und man weiss
    // nicht, ob etwas passiert ist.
    await new Promise((fertig) => setTimeout(fertig, 400));
  }, []);

  return (
    <PullToRefresh onRefresh={neuLaden}>
      <AppShell>
        <div key={stand}>
          <Routes>
            <Route path="/" element={<HeutePage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/event/:slug" element={<EventDetailPage />} />
            <Route path="/raids" element={<RaidsPage />} />
            <Route path="/fangen" element={<FangenPage />} />
            <Route path="/scan" element={<ScanPage />} />
            <Route path="/raid-team" element={<RaidTeamPage />} />
            <Route path="/statistik" element={<StatsPage />} />
            <Route path="/pvp" element={<PvpPage />} />
            <Route path="/pokemon" element={<PokemonPage />} />
            <Route path="/pokemon/:slug" element={<PokemonDetailPage />} />
            <Route path="/mein-bereich/*" element={<MyAreaPage />} />
            {/* Alter Pfad aus der Zeit vor "Dein Bereich" -- Lesezeichen sollen
                nicht ins Leere laufen. */}
            <Route path="/meine-pokemon" element={<Navigate to="/mein-bereich/pokemon" replace />} />
            <Route path="/konto" element={<AccountPage />} />
            <Route path="/passwort-vergessen" element={<PasswordForgotPage />} />
            <Route path="/passwort-neu" element={<PasswordResetPage />} />
            <Route path="/bestaetigen" element={<VerifyPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </AppShell>
    </PullToRefresh>
  );
}
